/**
 * Psalms & Palms Shopify Theme JavaScript
 */
document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initHeroSlider();
  initCategoryFilters();
});

/**
 * Mobile Drawer Menu
 */
function initMobileMenu() {
  const toggle = document.getElementById('mobile-menu-toggle');
  const close = document.getElementById('mobile-menu-close');
  const overlay = document.getElementById('mobile-menu-overlay');
  const drawer = document.getElementById('mobile-menu-drawer');

  if (!toggle || !close || !overlay || !drawer) return;

  function openMenu() {
    overlay.classList.remove('hidden');
    // Force reflow
    void overlay.offsetWidth;
    overlay.classList.add('opacity-100');
    drawer.classList.remove('-translate-x-full');
  }

  function closeMenu() {
    overlay.classList.remove('opacity-100');
    drawer.classList.add('-translate-x-full');
    setTimeout(() => {
      overlay.classList.add('hidden');
    }, 300);
  }

  toggle.addEventListener('click', openMenu);
  close.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
}

/**
 * Top Hero Image Slider
 */
function initHeroSlider() {
  const sliderSection = document.getElementById('hero-slider-section');
  if (!sliderSection) return;

  const slides = sliderSection.querySelectorAll('.slider-slide');
  const indicators = sliderSection.querySelectorAll('[data-slide-indicator]');
  const prevBtn = document.getElementById('slider-prev');
  const nextBtn = document.getElementById('slider-next');

  if (slides.length === 0) return;

  let currentIndex = 0;
  let autoplayTimer = null;

  const isAutoplay = sliderSection.getAttribute('data-autoplay') === 'true';
  const autoplaySpeed = parseInt(sliderSection.getAttribute('data-speed') || '6', 10) * 1000;

  function showSlide(index) {
    // Handle bounds
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    currentIndex = index;

    // Toggle active classes on slides
    slides.forEach((slide, i) => {
      if (i === currentIndex) {
        slide.classList.remove('opacity-0', 'z-0');
        slide.classList.add('opacity-100', 'z-10');
      } else {
        slide.classList.remove('opacity-100', 'z-10');
        slide.classList.add('opacity-0', 'z-0');
      }
    });

    // Toggle indicators
    indicators.forEach((indicator, i) => {
      if (i === currentIndex) {
        indicator.classList.remove('w-2', 'bg-white/40');
        indicator.classList.add('w-8', 'bg-[#cb5d4e]');
      } else {
        indicator.classList.remove('w-8', 'bg-[#cb5d4e]');
        indicator.classList.add('w-2', 'bg-white/40');
      }
    });

    // Reset autoplay timer
    if (isAutoplay) {
      resetAutoplay();
    }
  }

  function nextSlide() {
    showSlide(currentIndex + 1);
  }

  function prevSlide() {
    showSlide(currentIndex - 1);
  }

  function resetAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(nextSlide, autoplaySpeed);
  }

  // Click events
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);
  if (nextBtn) nextBtn.addEventListener('click', nextSlide);

  indicators.forEach((indicator, i) => {
    indicator.addEventListener('click', () => showSlide(i));
  });

  // Start Autoplay
  if (isAutoplay) {
    resetAutoplay();
  }
}

/**
 * Category Tab Filtering
 */
function initCategoryFilters() {
  // 1. Apparel Tab Filters
  const apparelTabs = document.getElementById('apparel-tabs');
  const apparelGrid = document.getElementById('apparel-grid');
  
  if (apparelTabs && apparelGrid) {
    const buttons = apparelTabs.querySelectorAll('button');
    const cards = apparelGrid.querySelectorAll('.product-card-item');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const tab = button.getAttribute('data-tab');

        // Toggle active button style
        buttons.forEach(btn => {
          btn.classList.remove('bg-white', 'shadow-sm', 'text-[#2c525e]');
          btn.classList.add('text-[#2c525e]/70');
        });
        button.classList.remove('text-[#2c525e]/70');
        button.classList.add('bg-white', 'shadow-sm', 'text-[#2c525e]');

        // Filter cards
        cards.forEach(card => {
          const subCategory = card.getAttribute('data-sub-category');
          if (tab === 'all') {
            card.classList.remove('hidden');
          } else if (tab === 'surf-tee') {
            if (subCategory === 'surf-tee' || subCategory === 't-shirt') {
              card.classList.remove('hidden');
            } else {
              card.classList.add('hidden');
            }
          } else {
            if (subCategory === tab) {
              card.classList.remove('hidden');
            } else {
              card.classList.add('hidden');
            }
          }
        });
      });
    });
  }

  // 2. Art Tab Filters
  const artTabs = document.getElementById('art-tabs');
  const artGrid = document.getElementById('art-grid');

  if (artTabs && artGrid) {
    const buttons = artTabs.querySelectorAll('button');
    const cards = artGrid.querySelectorAll('.product-card-item');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const tab = button.getAttribute('data-tab');

        // Toggle active button style
        buttons.forEach(btn => {
          btn.classList.remove('bg-white', 'shadow-sm', 'text-[#2c525e]');
          btn.classList.add('text-[#2c525e]/70');
        });
        button.classList.remove('text-[#2c525e]/70');
        button.classList.add('bg-white', 'shadow-sm', 'text-[#2c525e]');

        // Filter cards
        cards.forEach(card => {
          const subCategory = card.getAttribute('data-sub-category');
          if (tab === 'all') {
            card.classList.remove('hidden');
          } else {
            if (subCategory === tab) {
              card.classList.remove('hidden');
            } else {
              card.classList.add('hidden');
            }
          }
        });
      });
    });
  }
}
